import React from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import EmbedApp from './embed/EmbedApp'
import { isEmbed } from './embed/embedConfig'
import { auth0Config } from '@config/auth'
import './index.css'
import './styles/print-report.css' // CC-49339/49340: clean print output for reports

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry auth failures — the interceptor handles 401 redirect
        if (error?.response?.status === 401) return false
        return failureCount < 1
      },
      staleTime: 5 * 60 * 1000,
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root'))

if (isEmbed()) {
  // Embed mode (loaded inside an iframe by IQ or another approved app).
  // No Auth0Provider — token comes from the parent window via postMessage.
  // EmbedApp owns its own QueryClient + router.
  root.render(
    <React.StrictMode>
      <EmbedApp />
    </React.StrictMode>
  )
} else {
  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={auth0Config.domain}
        clientId={auth0Config.clientId}
        authorizationParams={auth0Config.authorizationParams}
        cacheLocation={auth0Config.cacheLocation}
        useRefreshTokens={auth0Config.useRefreshTokens}
      >
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </Auth0Provider>
    </React.StrictMode>
  )
}
